import React, { useState, useRef, useEffect } from 'react';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { createTheme } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import { enUS } from 'date-fns/locale';
import styles from './style.module.css';
import newDatePickerIcon from '@/assets/img/newDatePicker.svg';

const materialTheme = createTheme({
  overrides: {
    MuiPickersModal: {
      dialogRoot: {
        '& *': {
          fontFamily: 'Averta !important',
        },
      },
    },
    MuiFormControl: {
      root: {
        cursor: 'pointer',
        width: '100%',
        height: '100%',
      },
    },
    MuiSvgIcon: {
      root: {
        cursor: 'pointer',
      },
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#f8b100',
      },
    },
    MuiPickersDay: {
      daySelected: {
        backgroundColor: '#f8b100',
      },
    },
    MuiInputBase: {
      root: {
        fontFamily: 'Averta Light',
        fontSize: '13px',
        fontWeight: 400,
        color: '#131517',
        width: '100%',
        height: '100%',
        '& input': {
          fontFamily: 'Averta Light',
          fontSize: '13px',
          fontWeight: 400,
          color: '#131517',
          width: '100%',
          height: '100%',
          padding: '0',
          margin: '0',
        },
      },
    },
  },
});

const CustomDateInput = ({
  title,
  placeholder,
  value,
  onChange,
  format = 'MM/dd/yyyy',
  width,
  minWidth,
  required,
  font = false,
  fontSize,
  height = false,
  className,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <div
      className={styles.wrapper}
      style={{
        width: width || '100%',
        minWidth: minWidth,
        maxWidth: width || '100%',
      }}>
      {title && (
        <span className={font ? styles.biglabel : styles.label}>
          {title}
          {required && <span className={styles.requiredField}>*</span>}
          {required && <span className={styles.requiredText}>Required</span>}
        </span>
      )}

      <div
        className={`${font ? styles.selectBoxFont : styles.selectBox} ${
          isFocused ? styles.focused : ''
        } ${className || ''}`}
        style={{
          height: height,
          width: '100%',
          minWidth: minWidth,
        }}
        onClick={() => inputRef.current?.focus()}>
        <ThemeProvider theme={materialTheme}>
          <MuiPickersUtilsProvider
            utils={DateFnsUtils}
            locale={{ ...enUS, options: { weekStartsOn: 1 } }}>
            <DatePicker
              ref={inputRef}
              value={value}
              onChange={onChange}
              format={format}
              placeholder={placeholder}
              onFocus={handleFocus}
              onBlur={handleBlur}
              InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <img
                    src={newDatePickerIcon}
                    alt="Date Picker"
                    style={{ width: '16px', height: '16px', color: '#99A0AE' }}
                  />
                ),
                className: font ? styles.bigInput : styles.input,
                style: { fontSize: fontSize },
              }}
              {...props}
            />
          </MuiPickersUtilsProvider>
        </ThemeProvider>
      </div>
    </div>
  );
};

export default CustomDateInput;
